import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const PenggunaRHIKodeOKService = {}

PenggunaRHIKodeOKService.list = function (token, params) {
    return fetch({
        url: '/pengaturan/intra_user_rhi/data',
        method: 'get',
        params: params,
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default PenggunaRHIKodeOKService;
